export default "__VITE_ASSET__CWrnnrHR__"